export default function(record, commit) {
	if (record.id === 'profile') {
		commit('provider/addProvider')
	}
	else if (record.provider.endsWith(':message')) {
		commit('provider/addMessage')
	}
	else if (record.provider.endsWith(':schedule')) {
		commit('provider/addSchedule')
	}
}
